<template>
    <div class="grid gap-3">
        <div class="text-content-lg font-semibold">Send documents</div>
        <DsCard class="text-content-primary">
            <div class="flex items-center gap-3">
                <DsIcon
                    icon="fa-regular fa-file-lines"
                    size="md"
                />
                <p class="text-center text-content-lg">Send documents to a client</p>

                <div class="ml-auto">
                    <DsTooltip
                        :tooltipText="disabled ? `Please select a branch to upload documents` : undefined"
                        tooltipLocation="bottom"
                    >
                        <DsButton
                            :disabled
                            leading="fa-regular fa-circle-plus"
                            size="sm"
                            variant="secondary"
                            @click="$emit('addDocuments')"
                        >
                            Add documents
                        </DsButton>
                    </DsTooltip>
                </div>
            </div>
        </DsCard>
    </div>
</template>

<script setup lang="ts">
import DsCard from '@/components/design-system/DsCard.vue';
import DsIcon from '@/components/design-system/DsIcon.vue';
import DsButton from '@/components/design-system/button/DsButton.vue';
import DsTooltip from '@/components/design-system/tooltip/DsTooltip.vue';

defineProps<{
    disabled?: boolean;
}>();

defineEmits<{
    (event: 'addDocuments'): void;
}>();
</script>
